<template>
<div>

  <ul class=" mb-12 mt-12 rounded" style="border-bottom: 1px solid #B7BDCD; background:#EEEEEE; white-space:nowrap">
    <li
    style="display: inline-block"
    class=" px-3 my-auto"
      :class="[
        'custom-tab',
        tab.id === currentTab ? 'custom-tab__active' : 'custom-tab__inactive',
      ]"
      
      v-for="tab in tabs"
      :key="tab.id"
      @click="$emit('current-tab', tab.id)"
    >
      {{ tab.value }} 
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: "Tab",
  props: ["tabs", "currentTab"],

};
</script>

<style lang="scss" scoped>
.custom-tab {
  height: 32px;
  cursor: pointer;

  &__active {
    background: #ffffff;
    color: #fcc210;
  }

  &__inactive {
    background: #EEEEEE;
    color: #667499;
  }
}
</style>
